import * as yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

var requestSchema = yup.object({
  appointmentId: yup.number().required(),
  charge: yup.boolean().required(),
});

export function useMarkAppointmentAsNoShowMutation(options = {}) {
  var queryClient = useQueryClient();

  return useMutation(
    async (dto) => {
      var req = requestSchema.validateSync(dto, {
        strict: true,
      });
      return await http.get(
        HTTP_ENDPOINTS.appointments.markAsNoShow(req.appointmentId, req.charge),
      );
    },
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.appointments.appointment],
        });
        options.onSuccess?.(...args);
      },
    },
  );
}
